import { URLS } from 'utils/constants'
import { defaultOptions, doGetRequest, doPatchRequest } from './apiRequests'
import { Config } from 'config'

export interface Provider {
  name: string
  tag: string
  pcki_id: string
  guid: string
  hubProvider: boolean
  baseUrl: string
  level: string
}
export enum ProviderLevel {
  Listing = 'Listing',
  Member = 'Member',
}
export interface GetAllowedShowingProvidersResponse {
  currentProvider: Provider
  providers: Provider[]
}

// get Allowed Showing Providers
export const getAllowedShowingProvidersRequest = async (
  config: Config,
  memberKey: string,
): Promise<GetAllowedShowingProvidersResponse> => {
  const newOptions = defaultOptions
  newOptions.withCredentials = false

  const response = await doGetRequest(
    `${config.showingChoiceServicesUrl}${URLS.GET_ALLOWED_SHOWING_PROVIDERS}/${memberKey}`,
    false,
    true,
    newOptions,
    false,
  )

  return response as GetAllowedShowingProvidersResponse
}

// save Member's Default Showing Provider
export const saveDefaultShowingProviderRequest = (
  config: Config,
  memberKey: string,
  providerGuid: string,
) => {
  const newOptions = defaultOptions
  newOptions.withCredentials = false

  const payload = {
    showingProviderId: providerGuid,
  }

  return doPatchRequest(
    `${config.showingChoiceServicesUrl}${URLS.SAVE_DEFAULT_SHOWING_PROVIDER}/${memberKey}`,
    payload,
    false,
    true,
  )
}

export const getShowingProviderLinkRequest = async (
  config: Config,
  queryParams: Record<string, string>,
) => {
  const url = new URL(
    `${config.showingChoiceServicesUrl}${URLS.GET_SHOWING_PROVIDER_LINK}`,
  )
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key]),
  )
  const newOptions = {
    ...defaultOptions,
    withCredentials: false,
  }
  newOptions.withCredentials = false

  console.log(url.toString())
  const response = await doGetRequest(
    url.toString(),
    true,
    true,
    newOptions,
    false,
  )

  return response
}

export const fetchCognitoRegionConfig = async (config: Config) => {
  const regionCognitoConfUrl = `${config.showingChoiceServicesUrl}/config`
  const resp = await fetch(regionCognitoConfUrl)
  const regionConfig = await resp.json()

  return regionConfig
}
